import React, { useState } from "react";
import { Button } from "../../../../shared/Button/Button";
import styles from "../scss/Prescribers.module.scss";
import UpgradeEpcsModal from "./UpgradeEpcsModal";

const UpgradeEpcsButton = ({ id, setLocalPrescribers, initialFormValues }) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  return (
    <>
      <Button
        size="small"
        onClick={() => {
          setShowUpgradeModal(true);
        }}
        className={styles.upgradeDowngradeButton}
      >
        Upgrade to EPCS
      </Button>
      {showUpgradeModal && (
        <UpgradeEpcsModal
          onClose={() => setShowUpgradeModal(false)}
          id={id}
          setLocalPrescribers={setLocalPrescribers}
          initialFormValues={initialFormValues}
        />
      )}
    </>
  );
};

export default UpgradeEpcsButton;
